import React from 'react';

const PartA4 = ({ data, pageNumber = 1 }) => {
    // Handle both page 1 and page 2 of Part A4
    const isPage1 = pageNumber === 1;

    if (isPage1) {
        return <PartA4Page1 data={data} />;
    } else {
        return <PartA4Page2 data={data} />;
    }
};

// Page 1: Plans after School
const PartA4Page1 = ({ data }) => {
    return (
        <div className="report-page relative font-[poppins] bg-white" style={{
            width: '210mm',
            height: '297mm',
            padding: '20mm',
            margin: '0 auto',
            fontSize: '10pt',
            lineHeight: '1.4',
            color: '#333333',
            boxSizing: 'border-box',
            overflow: 'hidden',
            position: 'relative',
            breakInside: 'avoid',
            pageBreakInside: 'avoid'
        }}>
            {/* Orange corner triangles */}
            <div className="absolute top-0 right-0 w-0 h-0"
                style={{
                    borderTop: '80px solid #f1905b',
                    borderLeft: '80px solid transparent'
                }}>
            </div>
            <div className="absolute bottom-0 left-0 w-0 h-0"
                style={{
                    borderBottom: '80px solid #F97316',
                    borderRight: '80px solid transparent'
                }}>
            </div>

            {/* Header */}
            <div className="text-center mb-6">
                <h2 className="text-xl font-bold text-[#F97316] mb-1">PART A (4)</h2>
                <h3 className="text-lg font-bold text-black">Plans after School</h3>
            </div>

            {/* Section 1: The next big step */}
            <div className="mb-6">
                <div className="bg-[#BFDBFE] p-2 font-bold text-black flex items-center mb-2">
                    <span className="mr-2 text-xl">⚡</span>
                    The next big step of my life
                </div>

                <p className="font-medium mb-2 text-xs">After I finish school, I want to...</p>

                <div className="border border-blue-300 p-4 rounded">
                    <div className="grid grid-cols-4 gap-2 text-center">
                        <div className="flex flex-col items-center gap-1">
                            <div className="w-6 h-6 border border-black flex items-center justify-center">
                                {data?.plan_college_general && "✓"}
                            </div>
                            <span className="text-[10px] font-medium leading-tight">go to college for a general education</span>
                        </div>
                        <div className="flex flex-col items-center gap-1">
                            <div className="w-6 h-6 border border-black flex items-center justify-center">
                                {data?.plan_skill_training && "✓"}
                            </div>
                            <span className="text-[10px] font-medium leading-tight">take up a skill training full time</span>
                        </div>
                        <div className="flex flex-col items-center gap-1">
                            <div className="w-6 h-6 border border-black flex items-center justify-center">
                                {data?.plan_professional_institute && "✓"}
                            </div>
                            <span className="text-[10px] font-medium leading-tight">prepare for my next step for admission in a professional institute/college</span>
                        </div>
                        <div className="flex flex-col items-center gap-1 w-full">
                            <div className="w-6 h-6 border border-black flex items-center justify-center mb-1">
                                {data?.plan_other && "✓"}
                            </div>
                            <span className="text-[10px] font-medium w-full leading-tight">
                                Any other, please specify
                                <div className="mt-1 border-b-2 border-black h-4 text-xs">{data?.plan_other_text}</div>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Split Section */}
            <div className="grid grid-cols-2 gap-4 mb-6">
                {/* Left Column */}
                <div className="bg-[#DBEAFE] p-4 border border-blue-200">
                    <h4 className="font-bold text-xs mb-3 border-b border-blue-300 pb-1">
                        I plan to go to college/Skill institute/professional institute
                    </h4>

                    <div className="space-y-3">
                        <div>
                            <label className="block text-[10px] font-medium mb-0.5">College/Skill Institute/Professional Institute:</label>
                            <div className="border-b border-black h-4 text-xs">{data?.institute_name}</div>
                        </div>

                        <div>
                            <label className="block text-[10px] font-medium mb-0.5">Course/Skill Training:</label>
                            <div className="border-b border-black h-4 text-xs">{data?.course_name}</div>
                        </div>

                        <div>
                            <label className="block text-[10px] font-medium mb-1">Type of Course:</label>
                            <div className="flex gap-2">
                                <div className="flex items-center gap-1">
                                    <div className="w-4 h-4 border border-black flex items-center justify-center text-[10px]">
                                        {data?.course_type_certificate && "✓"}
                                    </div>
                                    <span className="text-[10px]">Certificate</span>
                                </div>
                                <div className="flex items-center gap-1">
                                    <div className="w-4 h-4 border border-black flex items-center justify-center text-[10px]">
                                        {data?.course_type_diploma && "✓"}
                                    </div>
                                    <span className="text-[10px]">Diploma</span>
                                </div>
                                <div className="flex items-center gap-1">
                                    <div className="w-4 h-4 border border-black flex items-center justify-center text-[10px]">
                                        {data?.course_type_degree && "✓"}
                                    </div>
                                    <span className="text-[10px]">Degree</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Right Column */}
                <div className="bg-[#DBEAFE] p-4 border border-blue-200">
                    <h4 className="font-bold text-xs mb-3 border-b border-blue-300 pb-1">
                        I plan to pursue a skill-based course. I would like to work...
                    </h4>

                    <div className="space-y-2">
                        <div className="flex items-center gap-2">
                            <div className="w-4 h-4 border border-black flex items-center justify-center text-[10px]">
                                {data?.work_corporation && "✓"}
                            </div>
                            <span className="text-[10px]">in a corporation or private business</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <div className="w-4 h-4 border border-black flex items-center justify-center text-[10px]">
                                {data?.work_own_business && "✓"}
                            </div>
                            <span className="text-[10px]">in my own business</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <div className="w-4 h-4 border border-black flex items-center justify-center text-[10px]">
                                {data?.work_family_business && "✓"}
                            </div>
                            <span className="text-[10px]">in my family business</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <div className="w-4 h-4 border border-black flex items-center justify-center text-[10px]">
                                {data?.work_government && "✓"}
                            </div>
                            <span className="text-[10px]">in government</span>
                        </div>

                        <div className="flex items-center gap-2 mt-1">
                            <div className="w-4 h-4 border border-black flex items-center justify-center text-[10px] shrink-0">
                                {data?.work_other && "✓"}
                            </div>
                            <span className="text-[10px] whitespace-nowrap">Any other</span>
                            <div className="border-b border-black h-4 text-xs w-full">{data?.work_other_text}</div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Discussion Table */}
            <div className="flex-1">
                <p className="font-medium text-xs mb-1">Please discuss the following with your teacher/counsellor/parent/caregiver/peer. <span className="text-[10px] text-gray-500">(Just mention in points)</span></p>

                <div className="grid grid-cols-3 border border-gray-300 h-full">
                    {/* Header Row */}
                    <div className="bg-[#BFDBFE] p-2 text-center font-bold text-[10px] border-r border-gray-300 border-b border-gray-300 flex items-center justify-center">
                        What strengths or abilities will be most helpful for you in fulfilling this plan?
                    </div>
                    <div className="bg-[#BFDBFE] p-2 text-center font-bold text-[10px] border-r border-gray-300 border-b border-gray-300 flex items-center justify-center">
                        What will you need to improve in order to achieve this plan?
                    </div>
                    <div className="bg-[#BFDBFE] p-2 text-center font-bold text-[10px] border-b border-gray-300 flex items-center justify-center">
                        What challenges do you think you will face in fulfilling this plan?
                    </div>

                    {/* Input Row */}
                    <div className="bg-[#DBEAFE] p-2 border-r border-gray-300 text-xs">
                        {data?.discussion_strengths}
                    </div>
                    <div className="bg-[#DBEAFE] p-2 border-r border-gray-300 text-xs">
                        {data?.discussion_improvements}
                    </div>
                    <div className="bg-[#DBEAFE] p-2 text-xs">
                        {data?.discussion_challenges}
                    </div>
                </div>
            </div>

            {/* Page Number */}
            <div className="absolute bottom-3 left-0 right-0 text-center text-xs font-medium">
                6
            </div>
        </div>
    );
};

// Page 2: Future Self
const PartA4Page2 = ({ data }) => {
    // Helper for slider visualization in report
    const SliderVisual = ({ value }) => (
        <div className="flex items-center gap-2 w-full">
            <span className="font-bold text-red-500 text-xs">-</span>
            <div className="flex-1 h-1.5 rounded-full bg-gradient-to-r from-red-500 via-yellow-400 to-green-500 relative">
                <div
                    className="absolute top-1/2 w-2.5 h-2.5 bg-black rounded-full border border-white transform -translate-y-1/2 -translate-x-1/2"
                    style={{ left: `${value || 0}%` }}
                />
            </div>
            <span className="font-bold text-green-500 text-xs">+</span>
        </div>
    );

    return (
        <div className="report-page relative font-[poppins] bg-white" style={{
            width: '210mm',
            height: '297mm',
            padding: '20mm',
            margin: '0 auto',
            fontSize: '10pt',
            lineHeight: '1.4',
            color: '#333333',
            boxSizing: 'border-box',
            overflow: 'hidden',
            position: 'relative',
            breakInside: 'avoid',
            pageBreakInside: 'avoid'
        }}>
            {/* Orange corner triangles */}
            <div className="absolute top-0 right-0 w-0 h-0"
                style={{
                    borderTop: '80px solid #f1905b',
                    borderLeft: '80px solid transparent'
                }}>
            </div>
            <div className="absolute bottom-0 left-0 w-0 h-0"
                style={{
                    borderBottom: '80px solid #F97316',
                    borderRight: '80px solid transparent'
                }}>
            </div>

            {/* Header */}
            <div className="bg-[#BFDBFE] p-2 font-bold text-black flex items-center justify-center mb-6 mt-4">
                <span className="mr-2 text-xl">📅</span>
                Let’s imagine your ‘Future Self’, 10 years from now...
            </div>

            {/* Future Self Table */}
            <div className="grid grid-cols-3 border border-blue-300 mb-8 h-64">
                {/* Headers */}
                <div className="bg-[#DBEAFE] p-2 text-center border-r border-blue-300 border-b border-blue-300 flex items-center justify-center">
                    <span className="font-bold text-xs">
                        What will you be doing to <span className="text-[#F97316]">improve</span> yourself?
                    </span>
                </div>
                <div className="bg-[#DBEAFE] p-2 text-center border-r border-blue-300 border-b border-blue-300 flex items-center justify-center">
                    <span className="font-bold text-xs">
                        What will you be doing to <span className="text-[#F97316]">support</span> your friends and family?
                    </span>
                </div>
                <div className="bg-[#DBEAFE] p-2 text-center border-b border-blue-300 flex items-center justify-center">
                    <span className="font-bold text-xs">
                        What will you be doing to <span className="text-[#F97316]">improve</span> society?
                    </span>
                </div>

                {/* Inputs */}
                <div className="bg-[#EFF6FF] border-r border-blue-300 p-2 text-xs text-center">
                    {data?.future_improve_self}
                </div>
                <div className="bg-[#EFF6FF] border-r border-blue-300 p-2 text-xs text-center">
                    {data?.future_support_family}
                </div>
                <div className="bg-[#EFF6FF] p-2 text-xs text-center">
                    {data?.future_improve_society}
                </div>
            </div>

            {/* Feelings Section */}
            <div className="mb-8">
                <div className="bg-[#BFDBFE] p-1.5 font-bold text-center text-black mb-4 text-sm">
                    How do I feel about my future?
                </div>

                <p className="font-bold mb-4 text-xs">Circle as applicable.</p>

                <div className="grid grid-cols-2 gap-x-12 gap-y-6">
                    <div>
                        <div className="font-bold text-xs mb-1">Prepared</div>
                        <SliderVisual value={data?.feeling_prepared} />
                    </div>
                    <div>
                        <div className="font-bold text-xs mb-1">Excited</div>
                        <SliderVisual value={data?.feeling_excited} />
                    </div>
                    <div>
                        <div className="font-bold text-xs mb-1">Confident</div>
                        <SliderVisual value={data?.feeling_confident} />
                    </div>
                    <div>
                        <div className="font-bold text-xs mb-1">Curious</div>
                        <SliderVisual value={data?.feeling_curious} />
                    </div>
                </div>
            </div>

            {/* Reflection Boxes */}
            <div className="grid grid-cols-2 gap-4 h-64">
                <div className="border border-blue-400 flex flex-col">
                    <div className="bg-[#3B82F6] text-white font-bold text-center py-1 mx-8 mt-3 text-xs shadow-sm">
                        Why do you think so?
                    </div>
                    <div className="flex-1 p-3 text-xs">
                        {data?.future_why_think_so}
                    </div>
                </div>
                <div className="border border-blue-400 flex flex-col">
                    <div className="bg-[#3B82F6] text-white font-bold text-center py-1 mx-8 mt-3 text-xs shadow-sm">
                        Parents’ feedback
                    </div>
                    <div className="flex-1 p-3 text-xs">
                        {data?.future_parents_feedback}
                    </div>
                </div>
            </div>

            {/* Page Number */}
            <div className="absolute bottom-3 left-0 right-0 text-center text-xs font-medium">
                7
            </div>
        </div>
    );
};

export default PartA4;